
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'list': {
    width: 18.5,
    height: 9.5,
    viewBox: '0 0 18.5 9.5',
    data: '<g _fill="none" _stroke="#2e3640" stroke-linecap="round" stroke-width="1.5" data-name="Groupe 4771"><path pid="0" d="M.75.75h13" data-name="Ligne 211"/><path pid="1" d="M.75 4.75h17" data-name="Ligne 212"/><path pid="2" d="M.75 8.75h13" data-name="Ligne 213"/></g>'
  }
})
